// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1SkHQ","noInteraction":"EventWrapper_noInteraction__1w9g6","pointerPassthrough":"EventWrapper_pointerPassthrough__2HNM9"};